export default "__VITE_ASSET__B1A2IdA8__"